import styled from 'styled-components';
import {
	compose,
	space,
	typography,
	color,
	colorStyle,
	textStyle,
	borderRadius,
	layout,
	flexbox,
	grid,
	position,
	background,
	SpaceProps,
	TypographyProps,
	ColorProps,
	ColorStyleProps,
	TextStyleProps,
	BorderRadiusProps,
	LayoutProps,
	FlexboxProps,
	GridProps,
	PositionProps,
	FlexGrowProps,
	BackgroundProps
} from 'styled-system';
// import theme from 'styled-theming';

interface Props
	extends SpaceProps,
		TypographyProps,
		ColorProps,
		ColorStyleProps,
		TextStyleProps,
		BorderRadiusProps,
		LayoutProps,
		FlexboxProps,
		GridProps,
		PositionProps,
		FlexGrowProps,
		BackgroundProps {}

const Box = styled('div')<Props>(
	compose(space, typography, color, colorStyle, textStyle, borderRadius, layout, flexbox, grid, position, background)
);

// const BoxButtonWrapper = styled(Box)`
// 	background-color: var(--button-wrapper-bg);
// `;

export default Box;
